module.exports = __webpack_public_path__ + "static/media/FeaturedIn_Desktop_SV.9fac5b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FeaturedIn_Desktop_SV.png
// module id = 1049
// module chunks = 0